import { Link } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { formatFecha } from "@/lib/api";
import { CalendarDays, ArrowRight } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const MessageCard = ({ message }) => {
  const excerpt = message.conexion || message.mensaje || "";
  return (
    <Card
      className="group flex h-full flex-col overflow-hidden border-border bg-card shadow-[var(--shadow-sm)] transition-shadow duration-300 hover:shadow-[var(--shadow-md)]"
      data-testid={`message-card-${message.id}`}
    >
      {message.has_image && (
        <Link to={`/mensaje/${message.id}`} className="block h-40 overflow-hidden">
          <img
            src={`${BACKEND_URL}/api/messages/${message.id}/imagen?v=${message.imagen_version || 1}`}
            alt={message.titulo}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
        </Link>
      )}
      <CardContent className="flex flex-1 flex-col gap-3 p-5 sm:p-6">
        <div className="flex items-center gap-2 text-xs text-muted-foreground">
          <CalendarDays className="h-4 w-4" />
          <span data-testid="message-card-fecha">{formatFecha(message.fecha)}</span>
        </div>
        <h3 className="font-serif text-xl font-semibold leading-snug text-foreground">
          {message.titulo}
        </h3>
        <p className="text-sm font-medium text-primary">{message.pasaje}</p>
        <p className="line-clamp-3 text-sm text-muted-foreground">{excerpt}</p>
        <div className="mt-auto flex flex-wrap items-center gap-2 pt-2">
          {(message.tags || []).slice(0, 3).map((tag) => (
            <Badge key={tag} variant="secondary" className="bg-accent text-accent-foreground">
              {tag}
            </Badge>
          ))}
        </div>
        <Link
          to={`/mensaje/${message.id}`}
          className="mt-2 inline-flex items-center gap-1 text-sm font-semibold text-primary transition-colors duration-200 hover:text-primary/80"
          data-testid={`message-card-leer-${message.id}`}
        >
          Leer mensaje <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" />
        </Link>
      </CardContent>
    </Card>
  );
};
